import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['carousel']

  speed = '1000'
  slideCount = 5
  carouselArray = []

  connect() {
    this.speed = $(this.carouselTarget).data('speed')
    this.slideCount = $(this.carouselTarget).data('slideCount')
    this.setCarouselArray()
    this.startCarousel()
  }

  startCarousel() {
    setTimeout(() => {
      this.moveCarousel()
    }, this.speed)
  }

  setCarouselArray() {
    const items = document.querySelectorAll('.gallery-item')
    this.carouselArray = [...items]
  }

  updateGallery() {
    this.carouselArray.forEach(el => {
      el.classList.remove(el.classList[1])
    })
    this.carouselArray.slice(0, this.slideCount).forEach((el, i) => {
      el.classList.add(`gallery-item-${i + 1}`)
    })
    this.startCarousel()
  }

  moveCarousel() {
    this.carouselArray.push(this.carouselArray.shift())
    this.updateGallery()
  }

}